'use client';

import { useEffect } from 'react';
import { toast } from 'sonner';

export function useErrorToast(error: unknown, message: string) {
  useEffect(() => {
    if (error) toast.error(message);
  }, [error, message]);
}
